export default __webpack_public_path__ + "static/media/eos-asm-banner.6e1f9938.png";